<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label">
  <div app-theme-option-content>
    <app-show-details-option [showDetails]="showDetails" (sendShowDetails)="receiveShowDetails($event)">
      <div app-show-details-option-content>
        <button *ngFor="let p of positions" mdbBtn (click)="receiveValue(p)" type="button" color="light" size="sm" class="px-2 z-depth-0 my-0 ml-1 mr-0" mdbWavesEffect>
          <i class="fas fa-arrow-alt-to-{{p}} fa-fw {{ p == themeOptions.options().legend.position ? color : 'blue-grey' }}-text"></i>
        </button>
      </div>
    </app-show-details-option>
  </div>
</app-theme-option>

<div *ngIf="showDetails">
  <app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categoriesAndLabel" [label]="type | chart" [dark]="4" *ngFor="let type of themeOptions.limitedTo(optionType)">
    <div app-theme-option-content>
      <button *ngFor="let p of positions" mdbBtn (click)="receiveValue(p, type)" type="button" color="light" size="sm" class="px-2 z-depth-0 my-0 ml-1 mr-0" mdbWavesEffect>
        <i class="fas fa-arrow-alt-to-{{p}} fa-fw {{ p == themeOptions.options(type).legend.position ? color : 'blue-grey' }}-text"></i>
      </button>
    </div>
  </app-theme-option>
</div>